/* Built In Imports */
import React, { useContext, useEffect, useRef, useState } from 'react';

/* External Imports */
import { Box, useDisclosure } from '@chakra-ui/react';
// import parser from 'html-react-parser';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

/* Internal Imports */
/* Components */
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import BannerContent from '@landing_pages/SadhguruExclusive/BannerContent';
import Faqsection from '@landing_pages/SadhguruExclusive/Faqsection';
import Features from '@landing_pages/SadhguruExclusive/Features';
import Previews from '@landing_pages/SadhguruExclusive/Previews';
import SubscriptionPlan from '@landing_pages/SadhguruExclusive/SubscriptionPlan';
import Testimonials from '@landing_pages/SadhguruExclusive/Testimonials';
import { AuthContext } from '@store/auth-context';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import {
  fetchFooterData,
  fetchHeaderMenuData,
  fetchHeaderTopMenuData,
} from 'services/commonService';
import {
  fetchExclusivePageData,
  getExclusiveLandingPaths,
} from 'services/exclusiveService';

/* Styles */

/**
 *
 * @param root0
 * @param root0.headerMenuData
 * @param root0.region
 * @param root0.language
 * @param root0.footerData
 * @param root0.pageData
 */
export default function Page({
  headerMenuData,
  region,
  language,
  footerData,
  pageData,
}) {
  // debugger;
  const [currentUserRegion, setCurrentUserRegion] = useState(region);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [arrowToggle, setArrowToggle] = useState(false);
  const [PackageData, setPackageData] = useState([]);

  const [youtubeurl, setYoutubeurl] = useState('');

  const toggleArrow = e => {
    const getRotation = e.target.style.transform;
    const getImage = e.target;
    if (getRotation == 'rotate(180deg)') {
      e.target.style.transform = 'rotate(0deg)';
    } else {
      e.target.style.transform = 'rotate(180deg)';
    }
  };

  const authContext = useContext(AuthContext);
  const myRef = useRef(null);

  useEffect(() => {
    const currentRegion = config.locales.find(
      locale => locale.region_sf === region
    ).region;
    authContext.RegionAndLang(region, language);
    setCurrentUserRegion(currentRegion);
    const currentUrl = window.location.hash;
    if (currentUrl?.indexOf('#meet-sadhguru') >= 0) {
      myRef?.current?.scrollIntoView();
    }
  }, [authContext, region, language]);
  return (
    <>
      <HeadComponent
        data={pageData._seoMetaTags}
        availableLocals={pageData.availableLocales}
      ></HeadComponent>
      <Box m="0 auto" className="clear">
        <Box position="relative" background="#121212">
          <Box
            background="linear-gradient(to top, rgba(18, 18, 18, 0), rgba(18, 18, 18, 0.58) 100%"
            w="100%"
            h="20%"
            top="0"
            left="0"
            pos="absolute"
          ></Box>
          <BannerContent
            sectionContent={pageData}
            region={region}
            language={language}
          />
          <Features
            sectionContent={pageData}
            region={region}
            language={language}
          />
          <Box
            background="url(/assets/images/paint-v-3-tall-seamless-loopable-2.png) 0 -23px"
            p="127px 0 0 0"
            textAlign="center"
            color="#ffffff"
            backgroundSize="45%"
            backgroundRepeat="repeat-x"
          >
            <Previews
              sectionContent={pageData}
              region={region}
              language={language}
            />
            <Box
              padding="100px 0 0 0"
              textAlign="center"
              w={{ base: 'auto', sm: '90%', lg: 'auto' }}
              m={{ sm: '0 auto' }}
            >
              <Testimonials
                sectionContent={pageData}
                region={region}
                language={language}
              />
              {PackageData && (
                <SubscriptionPlan
                  sectionContent={pageData}
                  region={region}
                  language={language}
                />
              )}
              <Faqsection
                sectionContent={pageData}
                region={region}
                language={language}
              />
              <Box
                background={`url('${config.imgPath}/d/46272/1644999728-footer-texture.jpg') repeat-x center`}
                // background="url(https://images.sadhguru.org/d/46272/1644999728-footer-texture.jpg) repeat-x center"
                min-height="250px"
                backgroundSize="100% 100%"
                p="84px 0 50px 0"
              >
                <LazyLoadImageComponent
                  title="logo"
                  alt="logo"
                  src={`${config.imgPath}/d/46272/1644999802-sgex-logo-new-white-2.svg`}
                />
                {/* <Image src="https://images.sadhguru.org/d/46272/1644999802-sgex-logo-new-white-2.svg"></Image> */}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <style global jsx>{`
        body {
          overflow-x: hidden;
        }
        .clear {
          clear: both;
        }
        .langopt-structure a {
          color: #cf4824;
        }
        .buttonlink:hover {
          text-decoration: none;
        }
        .loginlink p {
          color: #b0a999;
        }
        .loginlink a {
          border-bottom: 1px solid #ffbd31;
          color: #ffbd31;
        }
        .privacylink p {
          display: inline-block;
          whitespace: pre;
          padding: 40px 20px 0px 20px;
        }
        .privacylink p a {
          padding: 10px 30px;
          text-decoration: underline;
        }
        .feature_text a {
          color: #cf4520;
        }
        @media screen and (max-width: 768px) {
        }
      `}</style>
    </>
  );
}

export const getStaticPaths = async () => {
  let exclusiveLandingPath = config.USE_LOCAL_URL
    ? [`/in/en/sadhguru-exclusive`]
    : await getExclusiveLandingPaths('lvl0', '/sadhguru-exclusive', [
      '/sadhguru-exclusive-free-trial',
    ]);
  // console.log('exclusiveLandingPath', exclusiveLandingPath);
  if (
    exclusiveLandingPath?.length < 1 &&
    config.BUILD_URLS?.LANDING_PAGES?.SadhguruExclusive
  ) {
    const pageData = await fetchExclusivePageData();
    exclusiveLandingPath = pageData?.availableLocales
      ? pageData?.availableLocales?.map(locale => {
        return encodeURI(locale.value);
      })
      : [];
  }
  return {
    paths: exclusiveLandingPath,
    fallback: false,
  };
};

export const getStaticProps = async ({ params: { region, language }, req }) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchExclusivePageData(region, language);

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region,
      language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      page: 'Exclusive',
    },
  };
};
